import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ requiredRole }) => {
  const { user } = useSelector((state) => state.user);

  // console.log({ user });

  if (!user) {
    // return <Navigate to="/login" replace />;
    return <Navigate to="/intro" replace />;
  }

  if (requiredRole !== undefined && user.isAdmin !== requiredRole) {
    return <Navigate to="/intro" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
